import { authInstance } from './axios'
let url = process.env.REACT_APP_API_URL

let cachedListResponse = null
let pendingList = null

export const invalidateTimeParamsCache = () => {
  cachedListResponse = null
  pendingList = null
}

export const timeParamsService = {
  list: async () => {
    if (cachedListResponse) {
      return cachedListResponse
    }
    if (!pendingList) {
      pendingList = authInstance
        .get(`${url}/timeParams/list`)
        .then((response) => {
          if (response?.status === 200 && response?.data?.timeParams) {
            cachedListResponse = response
          }
          return response
        })
        .catch(function (error) {
          error.data = null
          return error
        })
        .finally(() => {
          pendingList = null
        })
    }
    return pendingList
  },
  save: async (data) => {
    const response = await authInstance
      .post(`${url}/timeParams/`, { data })
      .then(async (r) => r)
      .catch(function (error) {
        error.data = null
        return error
      })
    if (response?.status === 200) {
      invalidateTimeParamsCache()
    }
    return response
  },
}
